// extracted by mini-css-extract-plugin
module.exports = {"checkedFilter":"sp-management-filter_checkedFilter__3qQ7P"};